import logo from './logo.svg';
import './App.scss';
import './Reset.scss'
import './MediaQ.scss'
import NavBar from './components/nav/NavBar';
import Home from './components/home/Home'
import News from './components/library/News'
import Community from './components/community/Community'
import { Switch, Route } from 'react-router-dom'
import About from './components/about/About'
import Museum from './components/museum/Museum'
import Footer from './components/nav/Footer';
import MysteryGlyphs from './components/museum/MysteryGlyphs';
import OurArticles from './components/library/OurArticles';

function App() {
  return (
    <div className="App">
      <NavBar/>
      <Switch>
        <Route exact path='/' component={Home}/>
        <Route path='/news' component={News}/>
        <Route path='/articles' component={OurArticles}/>
        <Route path='/community' component={Community}/>
        <Route path='/about' component={About}/>
        <Route path='/mysteryglyphs' component={MysteryGlyphs}/>
        <Route path='/museum' component={Museum}/>
      </Switch>
      <Footer/>
    </div>
  );
}

export default App;
